module.exports = __webpack_public_path__ + "static/media/makeup_eye.b5529c09.jpg";